module.exports = __webpack_public_path__ + "img/donut.d63be2d0.svg";